import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { WebAuthLayout } from './WebAuthLayout';
import { CreateProfileScreen } from './CreateProfileScreen';
import { useAuth } from './AuthContext';
import { ApiError, NetworkError } from '../api/client';
import { NAV_PATH } from '../shell/nav';

export function WebCreateProfileScreen() {
  const { user, updateDisplayName } = useAuth();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const done = async (displayName: string) => {
    // Bỏ trống hoặc không đổi gì thì vào thẳng — đặt tên là tuỳ chọn.
    if (!displayName || displayName === user?.displayName) {
      navigate(NAV_PATH.hoc, { replace: true });
      return;
    }
    setError(null);
    setSaving(true);
    try {
      await updateDisplayName(displayName);
      navigate(NAV_PATH.hoc, { replace: true });
    } catch (err) {
      setError(err instanceof ApiError || err instanceof NetworkError ? err.message : 'Không lưu được tên, thử lại sau.');
      setSaving(false);
    }
  };

  return (
    <WebAuthLayout>
      <div
        style={{
          width: '100%',
          maxWidth: 460,
          height: 640,
          maxHeight: '86vh',
          background: 'var(--surface-page)',
          border: '1px solid var(--border-default)',
          borderRadius: 'var(--radius-card)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: 'var(--shadow-card)',
        }}
      >
        <CreateProfileScreen onDone={done} initialName={user?.displayName ?? ''} saving={saving} error={error} />
      </div>
    </WebAuthLayout>
  );
}
